import { getDocumentByFileStoreId } from "@egovernments/digit-ui-libraries/src/utils/fileType";
import ButtonWrapper from "@egovernments/digit-ui-module-obps/src/pages/citizen/TCPForms/components/Button";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { FaFilePdf } from "react-icons/fa";
import { Loader } from "@egovernments/digit-ui-react-components";

const ViewDocuments = ({ documentSection, setIsPreviewLoading, iframeSrc, setIframeSrc }) => {
  const [loading, setLoading] = useState(false);
  console.log("iframeSrcFromView", iframeSrc);

  const docSection = documentSection?.filter((doc) => !["signature", "applicantPhoto", "kmlFile"].includes(doc.documentType) && doc.isNoc !== "true") || [];
  const handleLoadPage = async (fileStoreId) => {
    const url = await getDocumentByFileStoreId(fileStoreId, setLoading, true);
    console.log("handleCHangeisTriggered", fileStoreId, typeof url, url);
    setIframeSrc(url);
  };
  const handleDownload = () => {
    if (iframeSrc) {
      const link = document.createElement("a");
      link.href = iframeSrc;
      link.download = "document.pdf"; // Optional: set file name
      link.click();
    } else {
      console.error("File not found.");
    }
  };
  return (
    <React.Fragment>
    <div className="view-documents-container">
  {/* Left Sidebar for Documents */}
  <div className="bg-white document-all-document">
    <strong>Documents</strong>
    {docSection.map((doc, index) => (
      <div key={doc.fileStoreId} className="document-item" onClick={() => handleLoadPage(doc.fileStoreId)}>
        <div className="document-info">
          <span>{index + 1} {doc?.additionalDetails?.title || doc?.documentType}</span>
        </div>
        <div className="document-icon">
          <FaFilePdf color="#a10505" className="view-doc-icon-pdf" />
        </div>
      </div>
    ))}
  </div>

  {/* Right Side for Iframe */}
  <div className="iframe-container">
  {loading ? (
    <Loader />
  ) : iframeSrc && iframeSrc.toLowerCase().includes(".kml") ? (
    <div style={{ padding: "20px" }}>
    </div>
  ) : (
    <iframe
      className="fastPas-iframe"
      src={iframeSrc}
      title="Document Viewer"
    ></iframe>
  )}
</div>

</div>

     
      {/* <div className="footerContainer2">
        <div className="buttonWrapper">
          <ButtonWrapper
            variant="contained"
            color="success"
            size="medium"
            label="Download"
            onClick={handleDownload}
            sx={{ backgroundColor: "#157CB3", marginRight: "4px" }}
          />
        </div>
      </div> */}
    </React.Fragment>
  );
};

export default ViewDocuments;
